/**
 * Base API Client
 * Foundation for all domain-specific API clients
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class BaseAPI {
    constructor(config, env) {
        this.config = config;
        this.env = env;
        this.userId = config.userId;
    }
    /**
     * Get user ID
     */
    getUserId() {
        return this.userId;
    }
    /**
     * Get user email from config
     */
    getUserEmail() {
        return this.config.emailAddress;
    }
    /**
     * Make a GET request
     */
    get(url_1) {
        return __awaiter(this, arguments, void 0, function* (url, headers = {}) {
            const response = yield fetch(url, {
                method: "GET",
                headers: Object.assign({ "Content-Type": "application/json" }, headers),
            });
            if (!response.ok) {
                throw new Error(`GET ${url} failed: ${response.statusText}`);
            }
            return yield response.json();
        });
    }
    /**
     * Make a POST request
     */
    post(url_1, body_1) {
        return __awaiter(this, arguments, void 0, function* (url, body, headers = {}) {
            const response = yield fetch(url, {
                method: "POST",
                headers: Object.assign({ "Content-Type": "application/json" }, headers),
                body: JSON.stringify(body),
            });
            if (!response.ok) {
                throw new Error(`POST ${url} failed: ${response.statusText}`);
            }
            return yield response.json();
        });
    }
    /**
     * Make a DELETE request
     */
    delete(url_1) {
        return __awaiter(this, arguments, void 0, function* (url, headers = {}) {
            const response = yield fetch(url, {
                method: "DELETE",
                headers: Object.assign({ "Content-Type": "application/json" }, headers),
            });
            if (!response.ok) {
                throw new Error(`DELETE ${url} failed: ${response.statusText}`);
            }
        });
    }
}
